// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"2e85e355","414":"a9f05975","981":"56f40194"}[chunkId] + ".chunk.css";
};